export default __webpack_public_path__ + "static/media/Autokritigallery_10.75246546.jpg";